// Registro ligero de errores en localStorage para observabilidad en producción.
// Captura errores de React (vía ErrorBoundary), errores globales y promesas rechazadas.

const KEY = 'app_error_log';
const MAX = 20;

export interface LoggedError {
  at: string;          // ISO timestamp
  message: string;
  source: string;      // 'react' | 'window' | 'promise'
  stack?: string;
  url?: string;
}

export function logError(message: string, source: string, stack?: string) {
  try {
    const entry: LoggedError = {
      at: new Date().toISOString(),
      message: String(message).slice(0, 500),
      source,
      stack: stack ? String(stack).slice(0, 2000) : undefined,
      url: typeof location !== 'undefined' ? location.hash || location.pathname : undefined,
    };
    const raw = localStorage.getItem(KEY);
    const list: LoggedError[] = raw ? JSON.parse(raw) : [];
    list.unshift(entry);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // si localStorage falla, no hacemos nada (no romper más)
  }
}

/** Devuelve los errores registrados (más reciente primero). */
export function getErrorLog(): LoggedError[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearErrorLog() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}

/** Instala los listeners globales (llamar una vez al arrancar la app). */
export function installGlobalErrorHandlers() {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (e) => {
    logError(e.message || 'Error global', 'window', e.error?.stack);
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason: any = e.reason;
    logError(reason?.message || String(reason) || 'Promesa rechazada', 'promise', reason?.stack);
  });
}
